import React from "react";
import { graphql, QueryRenderer } from "react-relay";
import environment from "./Environment";
import TopicScroll from "./TopicScroll";
import ThemeProvider from "./contexts/ThemeContext";

const sourcesQuery = graphql`
    query TopicScrollContainer_allCategories_Query {
        allCategories {
            ...TopicScroll_scroll_Categories
        }
    }
`;

function TopicScrollContainer(props) {
    let searchBy = "";

    const user = props.user;
    const settings = props.settings;

    return (
        <QueryRenderer
            environment={environment}
            query={sourcesQuery}
            render={({ error, props }) => {
                if (error) throw error;
                if (!props) return <div> ...Loading </div>;
                return (
                    <div>
                        <ThemeProvider>
                            <TopicScroll
                                user={user}
                                settings={settings}
                                scroll_Categories={props.allCategories}
                            />
                        </ThemeProvider>
                    </div>
                );
            }}
        />
    );
}

export default TopicScrollContainer;
